import React, { Component } from "react"
import { SelectWithSearch, HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { LoadModal } from "../modais"
export default class RelatorioContratadosForm extends Component {
  constructor() {
    super()
    this.getContratados = this.getContratados.bind(this)
    this.onChangeContratado = this.onChangeContratado.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      contratados: [],
      showLoad: false,
      contratado: ""
    }
  }
  componentWillMount() {
    this.getContratados()
  }
  onChangeContratado(event) {
    this.setState({
      contratado: event,
      formError: ""
    })
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      tipo_relatorio: "Contratados",
      contratado_id:
        this.state.contratado === undefined || this.state.contratado === null
          ? null
          : this.state.contratado.value
    }
    this.toggleLoadModal()
    ApiHelper.getRelatorioWith(params, relatorio => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Relatório de contratados.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        console.log("Error")
      }
    })
  }
  getContratados() {
    ApiHelper.getContratados((contratados, error) => {
      if (contratados) {
        var mapped = Util.mapContratados(contratados)
        mapped.shift()
        this.setState({
          contratados: mapped
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="row" style={{ marginTop: 100 }}>
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="card card-content">
        <div className="row">
          <LoadModal
            onClose={this.toggleLoadModal}
            show={this.state.showLoad}
          />
          <SelectWithSearch
            error={this.state.formError}
            sizeClass="col-md-8"
            options={this.state.contratados}
            label="Contratado"
            placeholder="Selecione um contratado ou deixe em branco para selecionar todos"
            onChange={this.onChangeContratado}
            value={this.state.contratado}
          />
        </div>
        <div className="row">
          <button
            onClick={this.sendForm}
            type="submit"
            className="btn btn-primary pull-left"
            data-background-color="as-blue"
          >
            Gerar
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/relatorios/RelatorioContratadosForm.js